angular.module("avlib").factory("avService", function (){

	var _removeCloak = function(){
		$('[av-cloak]').removeAttr("av-cloak");
	};
	
	return {
		removeCloak: _removeCloak,
	};
});
